import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles.css'; // Make sure this path is correct

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

reportWebVitals();
